"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchService = exports.RC_PROFILE_SITE_BROWSE = exports.RC_PROFILE_TOPICS_BROWSE = exports.RC_PROFILE_POSTS_BROWSE = exports.buildProfileSearchFlags = void 0;
const service_1 = require("./service");
const searchMapper_1 = require("../utils/searchMapper");
const searchFlags_1 = require("./searchFlags");
var searchFlags_2 = require("./searchFlags");
Object.defineProperty(exports, "buildProfileSearchFlags", { enumerable: true, get: function () { return searchFlags_2.buildProfileSearchFlags; } });
Object.defineProperty(exports, "RC_PROFILE_POSTS_BROWSE", { enumerable: true, get: function () { return searchFlags_2.RC_PROFILE_POSTS_BROWSE; } });
Object.defineProperty(exports, "RC_PROFILE_TOPICS_BROWSE", { enumerable: true, get: function () { return searchFlags_2.RC_PROFILE_TOPICS_BROWSE; } });
Object.defineProperty(exports, "RC_PROFILE_SITE_BROWSE", { enumerable: true, get: function () { return searchFlags_2.RC_PROFILE_SITE_BROWSE; } });
class SearchService extends service_1.Service {
    constructor(transport, auth) {
        super(transport, auth);
    }
    /**
     * Search forum content.
     * Command: "rc" (SEARCH_CONTENT) - 25458
     * @param query Search query
     * @param forumId Forum ID to search in (0 for all)
     * @param topicId Topic ID to search in (0 for all)
     * @param options Search options (offset, limit, sort, scope, result type)
     * @returns List of search results
     */
    async searchContent(query, forumId = 0, topicId = 0, authorId = 0, options = {}) {
        const { offset = 0, limit = 20, sort = 'rel', scope = 'all', resultType = 'posts', noHighlight = false, subforums = true // Default to true for broader results
         } = options;
        let flags = 0;
        // Subforums (recursion) flag - 131072 (1 << 17)
        if (subforums)
            flags |= 131072;
        // Scope flags
        if (scope === 'text')
            flags |= 1;
        else if (scope === 'title')
            flags |= 2;
        else if (scope === 'all')
            flags |= 3;
        else if (scope === 'site')
            flags |= 4;
        // Result type flags
        if (resultType === 'topics')
            flags |= 65536;
        // No highlight (and full text)
        if (noHighlight)
            flags |= 262144;
        // Sort flags
        if (sort === 'date_desc') {
            flags |= 524288;
        }
        else if (sort === 'date_asc') {
            flags |= 524288 | 1048576;
        }
        // IMPORTANT: The API Reference says "rc" command code is 25458.
        // The transport layer usually sends the string command code "rc" and handles the mapping if needed.
        // However, if the server expects numeric for some reason or if we need to be careful with flags.
        // Let's assume standard string command "rc" is correct as per other services.
        const response = await this.transport.send('rc', [flags, forumId, topicId, authorId, query, offset, limit]);
        this.checkError(response, 'rc');
        const data = response.data;
        return {
            results: searchMapper_1.SearchMapper.mapSearchResult(data),
            total: typeof data[0] === 'number' ? data[0] : 0,
        };
    }
    /**
     * Search posts or topics of a specific user (profile scope).
     * Android K0 / ProfilePage: `rc` with authorId, forum=0, topic=0.
     * Browse (empty query): flags 524289 (posts) or 589826 (topics), sort date_desc.
     */
    async searchProfileContent(userId, query = '', options = {}) {
        const { in: profileIn = 'posts', offset = 0, limit = 20, sort = 'date_desc', } = options;
        const flags = (0, searchFlags_1.buildProfileSearchFlags)(profileIn, sort);
        const response = await this.transport.send('rc', [
            flags,
            0,
            0,
            userId,
            query,
            offset,
            limit,
        ]);
        this.checkError(response, 'rc');
        const data = response.data;
        return {
            results: searchMapper_1.SearchMapper.mapSearchResult(data),
            total: typeof data[0] === 'number' ? data[0] : 0,
        };
    }
}
exports.SearchService = SearchService;
